import { useLoginUser } from './useLoginUser';
import { useValidationForm } from './useValidationForm';
import { useRecaptcha } from './useRecaptcha';
import { useHistory } from 'react-router-dom';
import { APP_PATH_ROOT } from '../config';

const schemaToValidate = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

export const useSignIn = () => {
  const { handleChange, hasError, formState } = useValidationForm({
    schemaToValidate
  });
  const history = useHistory();
  const { loginUser } = useLoginUser();
  const { executeRecaptcha } = useRecaptcha();

  const handleBack = () => {
    history.push(APP_PATH_ROOT);
  };

  const handleSignInNormal = async (formState) => {
    const {
      values: { email, password }
    } = formState;
    if (email && password) {
      // Execute reCAPTCHA before login
      const recaptchaToken = await executeRecaptcha('login');
      loginUser({ email, password, recaptchaToken });
    }
  };

  return {
    formState,
    handleChange,
    handleBack,
    handleSignInNormal,
    hasError
  };
};
